<template >
  <div class="over noselect">
    <!-- Blocco dei controlli -->
    <div id="amppeaks">
      <!-- Wrapper Info in Overlay -->
      <div class="infoi" v-show="!this.loaded">
        <h2>{{ $t("message.loading") }}...</h2>
      </div>
      <div class="over-info">
        <h2>{{ $t("title.anomalyDisp") }}</h2>
        <div id="date-select" @click="showCalendar = !showCalendar">
          <p class="info-btn">{{ $t("message.dateRange") }}:</p>
          <h2 class="info-btn">{{ this.formattedDate[0] + " - " + this.formattedDate[1] }}</h2>
          <i class="info-btn" v-bind:class="[showCalendar ? 'up' : 'down']"></i>
        </div>
      </div>
      <ModalCalendar
        v-if="showCalendar && getDateRange[0] && getDateRange[1]"
        :datarange="[getDateRange[0], getDateRange[1]]"
        @close="showCalendar = false"
        @update="updateDate"
        @range-selected="rangeSelected"
        :maxDate="isLambro ? new Date('2021-04-23') : new Date()"
        class="modal-calendar"
        id="calendar"
      />
      <!-- Blocco dell'anomaly plot -->
      <anomaly
        :xTitle="this.sensor1 ? this.sensor1.eui.substr(this.sensor1.eui.length - 4) + ' [mm]' : '-'"
        :yTitle="this.sensor2 ? this.sensor2.eui.substr(this.sensor2.eui.length - 4) + ' [mm]' : '-'"
        :tracesObject="this.getTraces"
        @events-selected="this.showModal"
      />
    </div>
    <!-- Blocco del componente modale con i grafici degli eventi -->
    <ModalWrapper v-show="isModalVisible" @close="closeModal" v-if="loaded && vibrationsResponse.length > 0">
      <template v-slot:body>
        <div class="plot-container">
          <LinePlot :title="vibrationsResponse[0].eui" :traces="[{ y: vibrationsResponse[0].payload.dati }]" xTitle="Time[samples]" yTitle="Pk-Pk[mm]" />
          <LinePlot :title="vibrationsResponse[1].eui" :traces="[{ y: vibrationsResponse[1].payload.dati }]" xTitle="Time[samples]" yTitle="Pk-Pk[mm]" />
        </div>
      </template>
    </ModalWrapper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCalendar from "../../ui/ModalCalendar";
import Anomaly from "../../graphs/Anomaly.vue";
import ModalWrapper from "../../ui/ModalWrapper.vue";
import LinePlot from "../../graphs/LinePlot.vue";
import axios from "axios";
import config from "../../../config";

export default {
  name: "anomaly-module",
  components: {
    Anomaly,
    ModalCalendar,
    ModalWrapper,
    LinePlot,
  },
  data() {
    return {
      showCalendar: false,
      loaded: false,
      firstExec: true,
      isModalVisible: false,
      selSensor1: "",
      selSensor2: "",
      event1: null,
      event2: null,
      vibrationsResponse: [],
      actualDateRange: [],
    };
  },
  computed: {
    ...mapGetters("anomaly", ["getDateRange", "getTraces"]),
    ...mapGetters("anomaly", ["getDispTraces"]),
    ...mapGetters({
      sensor1: "densProb1/getSelectedSensor",
      sensor2: "densProb2/getSelectedSensor",
      getSensors: "structure/getSensors",
    }),
    formattedDate() {
      let firstDate = this.formatDate(this.getDateRange[0]);
      let lastDate = this.formatDate(this.getDateRange[1]);
      return [firstDate, lastDate];
    },
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
  },

  methods: {
    ...mapActions("anomaly", ["setDateRange", "getAnomalyTraces"]),
    formatDate(date) {
      if (date) {
        let day = date.getDate();
        let year = date.getFullYear();
        let month = date.toLocaleString("default", { month: "short" });
        return day + " " + month + " " + year;
      } else {
        return null;
      }
    },
    updateDate() {
      this.setDateRange(this.actualDateRange);
      this.showCalendar = false;
    },
    rangeSelected(dateRange) {
      this.actualDateRange = dateRange;
    },
    async showModal(event1, event2) {
      this.event1 = event1;
      this.event2 = event2;
      await this.fetchSelectedEvents(event1, event2);
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    dateSelected: function (dateRange) {
      this.setDateRange(dateRange);
    },
    async fetchSelectedEvents(ID1, ID2) {
      this.loaded = false;
      const response = await axios.post(config.API_ENDPOINT + "sensor_data/vibrations", {
        ids: [ID1, ID2],
      });
      this.vibrationsResponse[0] = response.data[0];
      this.vibrationsResponse[1] = response.data[1];
      this.loaded = true;
    },
  },
  async mounted() {
    this.setDateRange([this.isLambro ? (new Date("2021-04-13")) : new Date().setDate(new Date().getDate() - 7), this.isLambro ? new Date("2021-04-23") : new Date()]);
  },
  watch: {
    getDateRange: {
      handler: async function () {
        this.loaded = false;
        await this.getAnomalyTraces();
        this.loaded = true;
      },
      deep: true,
    },
    sensor1: {
      handler: async function (value) {
        this.selSensor1 = value.eui;
        this.loaded = false;
        await this.getAnomalyTraces();
        this.loaded = true;
      },
      deep: true,
    },
    sensor2: {
      handler: async function (value) {
        this.selSensor1 = value.eui;
        this.loaded = false;
        await this.getAnomalyTraces();
        this.loaded = true;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* .modal-calendar {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(91, 96, 118);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
} */
#calendar {
  position: absolute;
  top: 93px;
  max-width: 770px;
  margin-left: 260px;
  background-color: rgb(45, 48, 65);
}

#date-select {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
}
#date-select p {
  margin-right: 10px;
}
/* Overlay Info */
.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-radius: 10px;
  font-size: 1.6em;
  background-color: black;
  z-index: 9;
  opacity: 0.7;
}
.infoi > h2 {
  margin: auto;
}
h2 {
  color: rgb(255, 255, 255);
}

.over {
  min-width: 800px;
  width: 92%;
  margin-left: 4%;
  margin-right: 4%;
  height: fit-content;
}
#amppeaks {
  display: grid;
  position: relative;
  margin-top: 30px;
  padding-bottom: 1%;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  overflow: hidden;
}
.plot-container {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 8px;
  justify-content: space-around;
}
.over-info {
  text-align: left;
  position: relative;
  margin-top: 2%;
  margin-bottom: 20px;
  display: grid;
  padding-left: 60px;
  padding-right: 60px;
  border-bottom: solid 1px rgba(255, 255, 255, 0.6);
  grid-template-columns: 100%;
}

/* Freccia */
i {
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 5px;
  position: relative;
  margin-bottom: auto;
  margin-top: auto;
  margin-left: 10px;
  bottom: 2px;
  transition: transform 0.3s cubic-bezier(0.42, 0, 0.1, 0.96);
}
.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
</style>